import Login from './login';

let routes = [];
routes = routes.concat({ path: 'login', exact: true, name: 'basic', component: <Login /> });

export default routes;
